<template>
  <div>
    <CRow>
      <CCol xs="12" sm="12" md="12" lg="4" xl="3">
        <CCard>
          <CCardHeader class="d-flex justify-content-between">
            <b><i class="fas fa-calendar"></i>&nbsp;Ventas</b>
          </CCardHeader>
          <CCardBody>
            <CRow>
              <CCol
                xs="12"
                sm="6"
                md="6"
                lg="12"
                v-if="$store.getters.get_rol.id !== 7"
              >
                <CSelect
                  label="Sede: "
                  :value.sync="campu_id"
                  :options="data_campus"
                  placeholder="--Seleccione una sede--"
                  @change="handleCampusChange"
                />
              </CCol>
            </CRow>
          </CCardBody>
        </CCard>
      </CCol>
      <CCol xs="12" sm="12" md="12" lg="8" xl="9">
        <CTableWrapper
          v-if="showSalesTable"
          :fields="fields"
          hover
          :striped="true"
          :border="true"
          :items="data"
          small
          fixed
          caption="Historial de créditos"
          icon="fas fa-coins"
          :size="'md'"
          :actions="true"
          :myButtons="myButtons"
          @mtd_view_history="mtd_view_history"
          :withActions="'2%'"
          @mtdBack="mtdBack"
        />
      </CCol>
    </CRow>

    <cModalHistoryCredits
      title="Historial de pagos"
      :boo_modal="boo_modal_history"
      :item="chargeSelected"
      @closeModalHistoryCredits="mtdCloseModalHistory"
    />
  </div>
</template>

<script>
const fields = [
  { key: "index", label: "Id", _style: "width:1%" },
  { key: "campus_name", label: "Sede", _style: "width:10%;" },
  { key: "client_name", label: "Cliente", _style: "width:15%;" },
  { key: "client_document", label: "Documento", _style: "width:10%;" },
  { key: "date_formatted", label: "Fecha", _style: "width:10%;" },
  { key: "total", label: "Total", _style: "width:8%;" },
  { key: "ajustement_amount", label: "Ajuste", _style: "width:8%;" },
  { key: "total_payment", label: "Total Pagado", _style: "width:8%;" },
  { key: "pending", label: "Pendiente", _style: "width:8%;" },
  { key: "status", label: "Estado", _style: "width:8%;" },
];

import CTableWrapper from "../../../components/shared/datatable/Table.vue";
import cModalHistoryCredits from "./modals/cModalHistoryCredits.vue";
import { mapActions } from "vuex";
import moment from "moment";
export default {
  components: {
    CTableWrapper,
    cModalHistoryCredits,
  },

  data() {
    return {
      prefix: "report",
      fields,
      data_campus: [],
      campu_id: 0,
      data: [],
      showSalesTable: true,
      myButtons: [
        {
          class: "btn-sm",
          color: "primary",
          tooltip: "Ver historial de pagos",
          action: "mtd_view_history",
          icon: "fas fa-eye",
        },
      ],
      boo_modal_history: false,
      chargeSelected: [],
    };
  },
  created() {
    this.getCampus();
    this.mtd_data();
  },
  methods: {
    ...mapActions(["get", "post"]),
    mtdBack: function () {
      this.$emit("mtdBack");
    },
    getCampus() {
      this.get({
        url:
          this.$store.getters.get__url +
          "/users/bycampus/" +
          this.$store.getters.get_company.id,
        token: this.$store.getters.get__token,
      }).then((response) => {
        if (response.statusCode == 200) {
          this.data_campus.push({
            label: "Todos",
            value: 0,
          });

          response.data.forEach((element) => {
            this.data_campus.push({
              label: element.name,
              value: element.id,
            });
          });
        }
      });
    },
    mtd_data() {
      let campu_id =
        this.$store.getters.get_rol.id == 7
          ? this.$store.getters.get_campu.id
          : this.campu_id;
      this.post({
        url: this.$store.getters.get__url + "/" + this.prefix + "/creditSales",
        token: this.$store.getters.get__token,
        params: {
          campu_id: campu_id,
        },
      })
        .then((response) => {
          this.data = response.data;

          let index = 1;
          this.data.forEach((item) => {
            item.index = index++;
            item.campus_name = item.campu?.name || "No especificado";
            item.client_name = item.client?.name || "No especificado";
            item.client_document = item.client?.document || "-";
            item.date_formatted = moment(item.date).format("DD/MM/YYYY");
            item.total = this.mtdMoney(item.total);
            item.ajustement_amount = this.mtdMoney(item.ajustement_amount);
            item.total_payment = this.mtdMoney(item.total_payment);
            item.pending = this.mtdMoney(item.pending);
            item.status = item.payment_status == 1 ? "Pagado" : "Pendiente";
          });
        })
        .catch((errors) => {
          Swal.fire({
            title: errors,
            icon: "danger",
          });
        });
    },
    mtd_view_history(item) {
      this.chargeSelected = item.charge || [];
      this.boo_modal_history = true;
    },
    mtdCloseModalHistory() {
      this.boo_modal_history = false;
      this.chargeSelected = [];
    },
    mtdMoney(value) {
      return "S/. " + parseFloat(value || 0).toFixed(2);
    },
    handleCampusChange() {
      this.mtd_data();
    },
  },
};
</script>

<style lang="scss" scoped></style>
